/* eslint-disable */

import React, { useEffect } from 'react'
import { object } from 'prop-types'

const Hotjar = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.id = 'hotjar'

    script.append(`
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:1404937,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `)

    document.body.append(script)
  }, [])

  return null
}

Hotjar.propTypes = {
  router: object
}

export default Hotjar
